<template>
  <v-dialog
    v-model="groupFormDialog"
    max-width="800px"
    :transition="true"
    persistent
  >
    <v-card
      :loading="dialogLoading"
      :disabled="dialogLoading"
      style="z-index: 99999"
    >
      <v-card-title class="headline grey lighten-3">
        <i class="fal fa-user-friends mr-2" style="font-size: 25px"></i>
        <span class="headline">{{ titleForm }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                ref="inputFieldForGroupName"
                v-model="editedItem.name"
                label="Group Name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                v-model="editedItem.dealer_id"
                :items="dealers"
                item-text="name"
                item-value="id"
                :menu-props="{ closeOnClick: true }"
                label="Select Dealer"
                @change="changedDealer"
                append-icon=""
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-card class="mx-auto">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="text-h5">
                      Members
                    </v-list-item-title>
                    <v-autocomplete
                      v-model="editedItem.users"
                      multiple
                      item-text="name"
                      item-value="id"
                      persistent-hint
                      append-icon=""
                      :label="` ${
                        editedItem.dealer_id
                          ? ''
                          : '(Select A Dealer To be able to select Members)'
                      }`"
                      :disabled="editedItem.dealer_id ? false : true"
                      :items="users"
                      :menu-props="{ closeOnClick: true }"
                      :search-input.sync="searchUsers"
                      @change="changedUser"
                      small
                      hint="Click on the selection form to add member"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          @click="data.select"
                          @click:close="remove(data.item)"
                        >
                          <v-avatar left>
                            <v-icon small>fa fa-user</v-icon>
                          </v-avatar>
                          {{ data.item.name }}
                        </v-chip>
                      </template>
                      <template v-slot:item="{ attrs, item, on }">
                        <v-list-item
                          v-show="!isAlreadySelected(item)"
                          v-on="on"
                          v-bind="attrs"
                        >
                          <v-list-item-content>
                            <v-row
                              no-gutters
                              align="center"
                              style="font-size: 15px"
                            >
                              <span>
                                <i class="fas fa-user mr-2"></i>
                              </span>
                              <span
                                style="font-weight: 400"
                                v-html="item.name"
                              ></span>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue-grey darken-1" text @click="close()">Cancel</v-btn>
        <v-btn
          :loading="dialogLoading"
          color="blue darken-1"
          text
          @click="submit()"
        >
          {{ isUpdate ? 'Update' : 'Save' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { some as _some, find as _find } from 'lodash-es';

export default {
  name: 'AddNewGroupDialog',
  data() {
    return {
      dialogLoading: false,
      groupFormDialog: false,
      editedItem: {
        id: null,
        name: '',
        users: [],
        dealer_id: null,
        specific_dealer_id: null,
      },
      specificDealers: [],
      searchUsers: '',
      defaultItem: {
        id: null,
        name: '',
        users: [],
        dealer_id: null,
        specific_dealer_id: null,
      },
      editedIndex: -1,
      users: [],
      groups: [],
      titleForm: 'Create New Group',
      isUpdate: false,
    };
  },
  computed: {
    isSpecificDealer() {
      const roles = this.$auth.user().roles;
      return _some(roles, { name: 'specific-dealer-manager' });
    },
    isAccountManager() {
      const roles = this.$auth.user().roles;
      return _some(roles, { name: 'account-manager' });
    },
    isSuperAdmin() {
      const roles = this.$auth.user().roles;
      return _some(roles, { name: 'super-administrator' });
    },
    dealers() {
      if (this.isSuperAdmin) {
        return this.$store.state.dealers.dealers;
      } else {
        return this.$store.state.dealers.dealers.filter(
          (dealer) => dealer.id === this.user.dealer_id
        );
      }
    },
    user() {
      return this.$auth.user();
    },
  },
  methods: {
    changedUser() {
      this.searchUsers = '';
    },
    toggleDialog(title = 'Create New Group', item = false) {
      this.isUpdate = false;
      this.editedItem.id = null;
      this.editedItem.dealer_id = null;
      this.editedItem.name = '';
      this.editedItem.users = [];
      this.editedItem.specific_dealer_id = null;
      this.titleForm = title;
      setTimeout(
        () => this.$refs.inputFieldForGroupName.$refs.input.click(),
        100
      );

      if (this.isSpecificDealer || this.isAccountManager) {
        this.editedItem.dealer_id = this.$auth.user().dealer_id;
        this.changedDealer();
      }

      if (item) {
        this.isUpdate = true;
        Object.assign((this.editedItem.users = item.users));
        this.editedItem.id = item.id;
        this.editedItem.name = item.name;
        this.editedItem.dealer_id = item.dealer_id;

        // Get users
        this.dialogLoading = true;
        this.$http
          .get(`/dealer/${item.dealer_id}/users`)
          .then((response) => {
            this.users = response.data.users;
            this.dialogLoading = false;
          })
          .catch(() => {
            this.dialogLoading = false;
          });
      }

      this.groupFormDialog = !this.groupFormDialog;
    },
    changedDealer() {
      if (this.editedItem.dealer_id) {
        this.users = [];
        this.specificDealers = [];
        this.editedItem.users = [];

        const currentDealer = _find(this.dealers, {
          id: this.editedItem.dealer_id,
        });

        if (currentDealer.is_automotive) {
          this.specificDealers = currentDealer.specific_dealers;
        }

        this.dialogLoading = true;
        this.$http
          .get(`/dealer/${this.editedItem.dealer_id}/users`)
          .then((response) => {
            this.users = response.data.users;
            this.dialogLoading = false;
          })
          .catch((e) => {
            console.log(e);
            this.dialogLoading = false;
          });
      }
    },
    close() {
      this.$emit('closedModal');
      this.editedItem = {
        id: null,
        name: '',
        users: [],
        dealer_id: null,
        specific_dealer_id: null,
      };
      this.users = [];
      this.groupFormDialog = false;
    },
    submit() {
      this.dialogLoading = true;
      if (this.editedItem.name === '' || this.editedItem.name == null) {
        this.$notify('warning', 'Oops! Name field is empty.');
        this.dialogLoading = false;
        return;
      }

      if (this.editedItem.dealer_id == null || this.editedItem.dealer_id < 0) {
        this.$notify('warning', 'Oops! Please Select A Dealer.');
        this.dialogLoading = false;
        return;
      }

      if (this.editedItem.users.length < 1) {
        this.$notify('warning', 'Oops! Please Choose Members');
        this.dialogLoading = false;
        return;
      }

      this.editedItem.specific_dealer_id = this.user.specific_dealer_id;
      if (!this.isUpdate) {
        this.save();
      } else {
        this.update();
      }
    },
    save() {
      this.$http
        .post('groups', this.editedItem)
        .then((response) => {
          this.dialogLoading = false;
          this.$notify('success', 'New group successfully created.');
          this.groups.push(response.data);
          this.$emit('changeEvent', response.data);
          this.close();
        })
        .catch((err) => {
          this.dialogLoading = false;
          this.$notify('error', err);
        });
    },
    update() {
      this.$http
        .put(`groups/${this.editedItem.id}`, this.editedItem)
        .then((response) => {
          this.dialogLoading = false;
          this.$notify('success', 'The group successfully updated.');
          this.groups.splice(this.editedIndex, 1, response.data);
          const item = response.data;
          item.isUpdate = true;
          this.$emit('changeEvent', item);
          this.close();
        })
        .catch((err) => {
          this.dialogLoading = false;
          this.$notify('error', err);
        });
    },
    remove(item) {
      const index = this.editedItem.users.indexOf(item.id);
      if (index >= 0) this.editedItem.users.splice(index, 1);
    },
    isAlreadySelected(item) {
      const index = this.editedItem.users.indexOf(item.id);
      return index >= 0;
    },
  },
};
</script>
<style scoped>
.v-icon {
  display: none !important;
}
</style>
